import { apiRequest, getApiSessionToken } from './apiClient';

const pendingOrganizationRequests = new Map();

export const isSaasOrganizationSelected = (organizationId, organizations) => {
  const selectedId = String(organizationId || '').trim();
  return Boolean(selectedId && Array.isArray(organizations)
    && organizations.some(organization => String(organization?.id || '').trim() === selectedId));
};

export const getSaasOrganization = (organizationId) => {
  const normalizedOrganizationId = String(organizationId || '').trim();
  if (!normalizedOrganizationId) {
    return Promise.reject(new Error('An organization must be selected before loading its details.'));
  }

  // The welcome page and sidebar both need this response. Share only an in-flight
  // request for the same organization and session; never cache balances.
  const sessionToken = getApiSessionToken();
  const requestKey = `${normalizedOrganizationId}\u0000${sessionToken}`;
  const pendingRequest = pendingOrganizationRequests.get(requestKey);
  if (pendingRequest) return pendingRequest;

  const request = apiRequest('/api/v1/saas/organization', {
    headers: { 'X-Organization-ID': normalizedOrganizationId },
  });
  const sharedRequest = request.finally(() => {
    if (pendingOrganizationRequests.get(requestKey) === sharedRequest) {
      pendingOrganizationRequests.delete(requestKey);
    }
  });
  pendingOrganizationRequests.set(requestKey, sharedRequest);
  return sharedRequest;
};
